// @ts-nocheck
import Form from '@rjsf/material-ui';
import validator from '@rjsf/validator-ajv8';
import produce from 'immer';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dimmer, Loader, Modal } from 'semantic-ui-react';
import useClients from '../../hooks/useClients';
import {
  createScheduledTask,
  setCreateScheduledTaskData,
} from '../../redux/actions/tasks';
import { StoreState } from '../../types/state';

const CreateScheduledTaskDialog = () => {
  const { clients, isLoading, count } = useClients();
  const scheduledTaskData = useSelector((state: StoreState) => {
    return state.tasks.scheduledTaskData;
  });
  const [updated, setUpdated] = useState(false);
  const [formSchema, setFormSchema] = useState({
    title: 'Add Scheduled Tasks',
    type: 'object',
    properties: {
      clientId: {
        type: 'number',
        title: 'Client',
        oneOf: [],
      },
      taskId: {
        type: 'string',
        title: 'Task Id',
        default: '',
        readOnly: true,
      },
      schedule: {
        type: 'string',
        title: 'Schedule',
        default: '',
        description: 'should be a valid cron tab syntax',
      },
      timezone: {
        type: 'string',
        title: ' TimeZone',
        default: '',
        description: 'time to schedule task for',
      },
    },
    required: ['clientId', 'taskId', 'schedule', 'timezone'],
  });
  const dispatch = useDispatch();

  const handleSubmit = ({ formData }) => {
    dispatch(createScheduledTask(formData));
  };

  useEffect(() => {
    if (scheduledTaskData) {
      setFormSchema((schema) => {
        return produce(schema, (draftSchema) => {
          draftSchema.title = `Add ${scheduledTaskData.Name}`;
          draftSchema.properties.taskId.default = scheduledTaskData.id;
          draftSchema.properties.timezone.default =
            scheduledTaskData.DefaultTimeZone;
          draftSchema.properties.schedule.default =
            scheduledTaskData.DefaultSchedule;
        });
      });
      setUpdated(true);
    }
  }, [scheduledTaskData, setUpdated]);

  useEffect(() => {
    if (count !== -1) {
      setFormSchema((schema) => {
        const clientsArr = Object.values(clients);
        return produce(schema, (draftSchema) => {
          draftSchema.properties.clientId.oneOf = clientsArr.map((client) => ({
            const: client.id,
            title: client.ClientName,
          }));
        });
      });
    }
  }, [clients, count]);

  return (
    <Modal open onClose={() => dispatch(setCreateScheduledTaskData(undefined))}>
      <Modal.Header>Schedule Task</Modal.Header>
      <Modal.Content>
        {isLoading || !updated ? (
          <Dimmer page>
            <Loader />
          </Dimmer>
        ) : (
          <Form
            schema={formSchema as any}
            onSubmit={handleSubmit}
            validator={validator}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};

export default CreateScheduledTaskDialog;
